const StringUtils = {

    snakeToCamel(stringInSnakeCase) {
        return stringInSnakeCase.replace(/(_\w)/g, m => m[1].toUpperCase());
    },

    //Turns string to upper case first character, every other character lower and no underscores format (e.g. ALL_DATA -> All data)
    //Currently only working for one space
    stringNormalize(str) {
        if (str) {
            let lowerStr = str.toLowerCase();
            lowerStr = lowerStr.replace("_", " ");
            let strSplit = lowerStr.split(" ");
            if (strSplit.length > 1) {
                let result = "";
                let currentWord;
                for (let i = 0; i < strSplit.length; i++) {
                    currentWord = strSplit[i];
                    result = result + currentWord[0].toUpperCase() + currentWord.slice(1) + " ";
                }
                return result;
            } else {
                return lowerStr.charAt(0).toUpperCase() + lowerStr.slice(1);
            }
        }
    }
};

export default StringUtils;